import {
    useCallback,
} from 'react'

import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import Typeahead from 'app/shared-components/Typeahead'
import requests from 'app/requests/Container/DamageType.requests'
import useGetDamageType from 'app/Apps/DamageTracking/hooks/useGetDamageType'

type Props = {
    name?: string,
    value?: {
        id: number,
    },
    onChange: (value: { id: number }) => void,
    title?: string,
    disabled?: boolean,
    required?: boolean,
}

const defaultProps: Partial<Props> = {
    name: '',
    value: undefined,
    title: 'Damage Type',
    disabled: false,
    required: false,
}

const DamageTypeSelector = ({
    name,
    value,
    onChange,
    title,
    disabled,
    required,
}: Props) => {
    const loadOptions = useDelayedLoadOptions(requests.selector)

    const {
        data: damageType,
    } = useGetDamageType(value?.id)

    const onChangeValue = useCallback((newValue: number) => {
        const convertedValue = newValue ? {
            id: newValue,
        } : undefined

        onChange(convertedValue)
    }, [onChange])

    return (
        <Typeahead
            name={name}
            title={title}
            onChange={onChangeValue}
            loadOptions={loadOptions}
            labelData={damageType}
            labelField="name"
            value={value?.id}
            disabled={disabled}
            isRequired={required}
        />
    )
}

DamageTypeSelector.defaultProps = defaultProps

export default DamageTypeSelector
